import { html } from '../lib/html.js';
import { config } from '../config.js';
import { session } from '../services/session.js';
import { Page, go } from './base.js';

/** Mostrada quando a API não responde. */
class OfflinePage extends Page {
  template() {
    return html`
      <ion-content class="ion-padding">
        <div class="narrow center">
          <ion-icon name="cloud-offline-outline" class="empty-icon"></ion-icon>
          <h2>Não foi possível conectar</h2>
          <p class="hint">Verifique sua internet. Em desenvolvimento, confira se o backend está rodando em
            <code>${config.apiUrl}</code>.</p>
          <ion-button expand="block" class="retry">
            <ion-icon slot="start" name="refresh-outline"></ion-icon>
            Tentar novamente
          </ion-button>
          <ion-button expand="block" fill="clear" color="medium" class="logout">Sair da conta</ion-button>
        </div>
      </ion-content>`;
  }

  setup() {
    this.$('.retry').addEventListener('click', () => go('/home', 'root'));
    this.$('.logout').addEventListener('click', async () => {
      await session.signOut();
      go('/login', 'root');
    });
  }
}

customElements.define('page-offline', OfflinePage);
